<template>
<div class="">


 

   <div class="yo-text-l yo-text-bold draft">ABSTRACTS IN DRAFT MODE</div>
   <div style="padding:4px 0 48px 0;">
	   <div class="yo-text-n yo-color-info">
      Abstracts that have not been sent for evaluation yet.
      <br />
      To modify your abstract(s), click on the title and review. Once you have updated your abstract, click on SUBMIT.
      <br /><br />
      <div class="yo-text-bold draft">ACTION LIST</div>
      » Click ADD / EDIT ABSTRACT to add or modify title, keywords and topic
      <br />
      » Click ADD / EDIT AUTHORS to add or modify all the authors
      <br />
      » Click ADD / EDIT TEXT to add or modify the text of the abstract
      <br />
      » Click MAKE PREVIEW to create pdf file of abstract
      <br />
      » Click SHOW PREVIEW to view the pdf file 
      <br />
      » Click SUBMIT to send your abstract to the Evaluation Committee
      <br />
      <br />
      <em class="danger yo-text-bold">Please remember to click on SUBMIT after displaying the preview.<br />If you don’t click on SUBMIT your abstract will not be accepted for evaluation and cannot be presented.</em>
      <br />
      <br />

      </div>
      <el-collapse accordion v-model="current" v-if="inlavorazione.length>0">
      <elCerca v-for="(item,index) in inlavorazione" :item="item" v-bind:key="item.id" :index="index" :current="current"></elCerca> 
      </el-collapse>
      <div v-else class="yo-text-n yo-color-info">No abstracts present at the moment</div>
   </div>



    <div class="yo-text-l yo-text-bold sent">SENT ABSTRACTS</div>
    <div style="padding:4px 0 48px 0;">
	   <div class="yo-text-n yo-color-info" style="padding-bottom:12px;">
      Abstracts sent for review and waiting for evaluation.
      </div>
      <el-collapse accordion v-model="current" v-if="inviati.length>0">
      <elCerca v-for="(item,index) in inviati" :item="item" v-bind:key="item.id" :index="index" :current="current"></elCerca> 
      </el-collapse>
      <div v-else class="yo-text-n yo-color-info">No abstracts present at the moment.</div>
   </div>



   <div class="yo-text-l yo-text-bold revised">ABSTRACTS TO BE REVISED</div>
   <div style="padding:4px 0 48px 0;">
      <div class="yo-text-n yo-color-info">
      Abstracts reviewed by the Evaluation Committee. Revisions or changes have been requested before final evaluation. </div>
      <el-collapse accordion v-model="current" v-if="revisione.length>0">
      <elCerca v-for="(item,index) in revisione" :item="item" v-bind:key="item.id" :index="index" :current="current"></elCerca> 
      </el-collapse>
      <div v-else class="yo-text-n yo-color-info">No abstracts present at the moment</div>
   </div>


<!-- per testare la funzionalità dopo il 31 gennaio 


<div v-if="$contatto.profile.row.id==341" class="row pad yo-bg-color-tertiary" style="margin-bottom:24px;background: #dbdbdb;">
   <div class="col s4 yo-align-center yo-text-l  yo-text-uppercase" style="margin:12px 0;color:red;">For testing only</div>
   <div class="col s4 yo-align-center">
    <el-switch style="margin:11px 0;display: block; " v-model="isafter" inactive-text="UNTIL 31 January 2021" active-text="FROM February 2021"></el-switch>
   </div>
   <div class="col s4 yo-align-center yo-text-l  yo-text-uppercase" style="margin:12px 0;color:red;">For testing only</div>
</div>
-->


   <div class="yo-text-l yo-text-bold accepted">ACCEPTED ABSTRACTS</div>
   <div style="padding:4px 0 48px 0;">
      <div class="yo-text-n yo-color-info">
      Abstracts accepted by the Evaluation Committee.
      <br /><br />

      <!--
      We gently remind authors that when submitting your abstract, you agreed that the abstract and the corresponding poster/presentation, which you are going to show during the ESPHM, subsequently may become available online at ECPHM's discretion.
<br />
You are requested to provide a PDF document before presenting your poster or giving your talk. Through this process, the ECPHM want to give all authors the chance to distribute their latest findings in science in a much better quality than it has been possible in the past editions of this and other conferences.
<br />
Taking pictures of displayed poster or filming of whole talks during sessions will not be allowed. Instead, authors are required to provide us with material (pdf) that can be published and attendees are requested to visit online at www.(sito college) to see this material.
<br />
Follow the instructions reported here below to upload the file of your e-poster or presentation:
<br /><br />
 -->




<!-- non usato nella edizione 2024 -->

<div v-if="isafter">
<br />

<div class="yo-text-bold accepted">ACCEPTED ABSTRACT ACTION LIST</div>
<ul>
<li>Click SHOW PREVIEW to view the pdf file</li>
</ul>
Follow the instructions reported here below to upload the file of your e-poster or presentation:
<br /><br />
<div class="yo-text-bold accepted">E-POSTER / PRESENTATION UPLOAD ACTION LIST</div>
<ul>
<li>Click ADD / REPLACE e-poster or presentation to upload your work or update it with a new file.</li>
<li>DROP the FILE or CLICK on the BUTTON to upload it</li>
<li>Click on SHOW E-POSTER OR PRESENTATION to view the file</li>
</ul>
You will have the chance to replace an already submitted presentation until May 6, 2025.
<br />
After that the latest version uploaded version is considered final, authors will no longer have the possibility to make any further amendments.
</div>











<!-- non usato nella edizione 2024
<div v-if="!isafter">
    

Should you have just registered and logged in, no abstract will be listed below.
<br />
Should you have submitted one or more abstracts before December 2019, and your abstract(s) been accepted, they will be listed below; in this case, please follow the instruction in the Action List.
<br /><br />

<div class="yo-text-bold accepted">ACCEPTED ABSTRACT ACTION LIST</div>

<ul>

   <li>If you wish to maintain your accepted abstract in its present form, please click on CONFIRM ABSTRACT.
   <br />
   Your work will be left unchanged and the corresponding allocated slot is maintained for the next edition of the Symposium.
   </li>

   <li>
   If you wish to make changes in your abstract or update it and resubmit it, please click on ENABLE EDITING.
   <br />
   Please remember that in this case, your work will become a new draft, will undergo the whole evaluation process and will release automatically the slot.
   </li>

   <li>
   If you wish to remove your accepted abstract, please click on DELETE ABSTRACT.
   <br />
   Your abstract will be cancelled and will release the corresponding slot.
   </li>

   <li>
   Click SHOW PREVIEW to view the pdf file
   </li>

</ul>
 <br /><br />
E-poster and Presentation Upload will be available after the abstract final evaluation and notification letters.
</div>


-->

















<br /><br />
 

      
      </div>
      <el-collapse accordion v-model="current" v-if="accettati.length>0">
      <elCerca v-for="(item,index) in accettati" :item="item" v-bind:key="item.id" :index="index" :current="current" :isafter="isafter"></elCerca>  
      </el-collapse>
      <div v-else class="yo-text-n yo-color-info">No abstracts present at the moment.</div>
   </div>

   <div class="yo-text-l yo-text-bold rejected">REJECTED ABSTRACTS</div>
   <div style="padding:4px 0 48px 0;">
      <div class="yo-text-n yo-color-info">
      Abstracts rejected by the Evaluation Committee.</div>
      <el-collapse accordion v-model="current" v-if="rifiutati.length>0">
      <elCerca v-for="(item,index) in rifiutati" :item="item" v-bind:key="item.id" :index="index" :current="current"></elCerca> 
      </el-collapse>
      <div v-else class="yo-text-n yo-color-info">No abstracts present at the moment.</div>
   </div>



</div>
</template>

<script>
import elCerca from './Abstract-elenco.vue'
export default {
   components: {
      elCerca
   }
   ,name: 'Cerca'
   ,data () {
      return {
         numitems: 0,
         current: '',
         isafter: true
      }
   },
  created () {
  }
   ,methods:{
   }
   ,computed: {

      /*
      ALTER TABLE `abstract` CHANGE `step` `step` INT(3) NOT NULL DEFAULT '0' COMMENT '0=draft, 10,20=send, 22=review, 11,21=accept, 90=declined, 99=delete';
      */
      inlavorazione: function(){
         this.numitems = this.$contatto._abstract.length
         let isFilter = []
         for (let item of this.$contatto._abstract)
            if(item.step==0)
               isFilter.push(item)
         this.numitems = isFilter.length
         return (isFilter.length>100) ? isFilter.slice(0, 100) : isFilter
      },
      inviati: function(){
         this.numitems = this.$contatto._abstract.length
         let isFilter = []
         for (let item of this.$contatto._abstract)
            if(item.step==10 || item.step==30 || item.step==50)
               isFilter.push(item)
         this.numitems = isFilter.length
         return (isFilter.length>100) ? isFilter.slice(0, 100) : isFilter
      },
      revisione: function(){
         this.numitems = this.$contatto._abstract.length
         let isFilter = []
         for (let item of this.$contatto._abstract)
            if(item.step==20)
               isFilter.push(item)
         this.numitems = isFilter.length
         return (isFilter.length>100) ? isFilter.slice(0, 100) : isFilter
      },
      accettati: function(){
         this.numitems = this.$contatto._abstract.length
         let isFilter = []
         for (let item of this.$contatto._abstract)
            if(item.step==99)
               isFilter.push(item)
         this.numitems = isFilter.length
         return (isFilter.length>100) ? isFilter.slice(0, 100) : isFilter
      },
      rifiutati: function(){
         this.numitems = this.$contatto._abstract.length
         let isFilter = []
         for (let item of this.$contatto._abstract)
            if(item.step==90)
               isFilter.push(item)
         this.numitems = isFilter.length
         return (isFilter.length>100) ? isFilter.slice(0, 100) : isFilter
      },
      filtrati: function () {
      this.numitems = this.$contatto._abstract.length

      console.log("TROVATI "+this.numitems+" ABSTRACT ora filtro per: "+this.$contatto.abstractCerca)
      
      if(this.numitems==0)
         return {}

      if(this.$contatto.abstractCerca=='' )
           return this.$contatto._abstract.slice(0, 100)
	 
		var words = this.$contatto.abstractCerca.toString().split('+')
		 
      
		var isFilter = []
		
      for (let item of this.$contatto._abstract){
			var trovati = 0
			for (let word of words){
				if(
            item.nome.toString().toLowerCase().indexOf(word.toLowerCase()) > -1 
            || 
            item.cognome.toString().toLowerCase().indexOf(word.toLowerCase()) > -1 
            || 
            item.ncartellaclinica.toString().toLowerCase().indexOf(word.toLowerCase()) > -1
            ) 
				trovati++
			}

			if(trovati==words.length)
				isFilter.push(item)
/*
         if(   
         (item.id>0) 
         && (
            item.nome.toString().toLowerCase().indexOf(this.$teras.contattoTermine.toLowerCase()) > -1 
            || 
            item.cognome.toString().toLowerCase().indexOf(this.$teras.contattoTermine.toLowerCase()) > -1 
            || 
            item.citta.toString().toLowerCase().indexOf(this.$teras.contattoTermine.toLowerCase()) > -1
            )
         )
         isFilter.push(item)
*/         

      }
      this.numitems = isFilter.length




      return (isFilter.length>100) ? isFilter.slice(0, 100) : isFilter
      
      }
   }
}

    
</script>

